import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import { TextField } from 'redux-form-material-ui';
import { Field } from 'redux-form';
import { email } from '../../lib/validators';
import { Row, Col } from 'react-flexbox-grid';
import {LoomisColors} from '../../lib/LoomisColors';
import translate from '../../lib/i18n/translate'

import './ForgotPasswordForm.css';

export const Error = ({text, error}) => {
    if(error) {
        return (
            <div className="error">
                <div>{text}</div>
                <div>{error.message}</div>
            </div>
        )
    }
    return (<div/>);
};

const styles = {
    errorStyle: {
       color: LoomisColors.red,
    },
    underlineStyle: {
        borderColor: LoomisColors.darkerRed,
    },
    floatingLabelStyle: {
        color: LoomisColors.blueGrey,
    },
    floatingLabelFocusStyle: {
        color: LoomisColors.blueGrey,
    },
    textFieldStyle: {
        color: LoomisColors.white,
    },
};

const ForgotPasswordForm = (props) => {

    const {EmailAddress, Submit, ErrorMessage} = props.strings;

    return (
        <div className="FormWrapper">
            <div className="container">
            <Row>
                <Col xs={12}>
                    <Row center="xs">
                        <Col xs={12} sm={6} md={4}>
                            <Error error={props.forgotPassword.error} text={ErrorMessage}/>
                            <form className="ForgotPassword" onSubmit={props.handleSubmit}>
                                <div>
                                    <Field
                                        name="email"
                                        validate={[email]}
                                        component={TextField}
                                        // hintText="E-mail address"
                                        floatingLabelText={EmailAddress}
                                        fullWidth={true}
                                        errorStyle={styles.errorStyle}
                                        underlineFocusStyle={styles.underlineStyle}
                                        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                        inputStyle={styles.textFieldStyle}
                                        />
                                </div>
                                <div className="ButtonWrapper">
                                    <FlatButton
                                        type="submit"
                                        backgroundColor="#fff"
                                        label={Submit}
                                        fullWidth={true} />
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Col>
            </Row>

            </div>
        </div>
    );
};

export default translate('ForgotPasswordForm')(ForgotPasswordForm);


// WEBPACK FOOTER //
// ./src/components/forgotPasswordForm/ForgotPasswordForm.js